import { render, staticRenderFns } from "./changeDutyStat.vue?vue&type=template&id=bef3e788&scoped=true"
import script from "./changeDutyStat.vue?vue&type=script&lang=js"
export * from "./changeDutyStat.vue?vue&type=script&lang=js"
import style0 from "./changeDutyStat.vue?vue&type=style&index=0&id=bef3e788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef3e788",
  null
  
)

export default component.exports